import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Route, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'sidenav-menu',
    template: `
    
    <div class="side-nav-item-menu" *ngIf="route?.children?.length">
        <div class="fieldset">
            <legend>
                {{route?.data?.title}}
            </legend>

            <ng-container *ngFor="let child of route.children">
                <a class="side-nav-item" routerLink="/{{route.path}}/{{child.path}}" routerLinkActive="active" [attr.data-tour-target]="child.path">

                    <i class="fa" [ngClass]="child.data.icon"></i>
                    <span>{{child?.data?.title}}</span>
                </a>
            </ng-container>

        </div>
    </div>
    
    `,
    styles: [
        `
            .side-nav-item.active { 
                color: #4faae7!important;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive]
})
export class SideNavMenuComponent {

    @Input() public route: Route;
}
